import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../security/authContext';
import { LuLogOut } from 'react-icons/lu';
import { Button } from 'react-bootstrap';

// loader not showing if data recived with 500ms
const timeouts = new Map();
let loaderTime = 500;
let ascStart = 0;
let ascStop = 0;



export function useFormLoader() {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.body.style.overflow = isLoading ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [isLoading]);

    const startLoading = useCallback(() => {
        if (timeouts.size > 0) {
            return;
        }
        ascStart = (ascStart + 1);
        const timer = setTimeout(() => {
            setIsLoading(true);
        }, loaderTime);

        timeouts.set(1, timer);
        // console.log(ascStart);

    }, []);
    const stopLoading = useCallback(() => {
        // ascStop = (ascStart + 1);
        setIsLoading(false);
        clearTimeout(timeouts.get(1));
        timeouts.delete(1);
        // console.log(ascStop);

    }, []);

    return { isLoading, startLoading, stopLoading };
}

const loaderStyles = `
    @keyframes formloader-morph {
        0%,100% { border-radius: 50%; transform: rotate(0deg) scale(1); }
        25%      { border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%; transform: rotate(90deg) scale(0.92); }
        50%      { border-radius: 50%; transform: rotate(180deg) scale(1.08); }
        75%      { border-radius: 70% 30% 30% 70% / 70% 70% 30% 30%; transform: rotate(270deg) scale(0.92); }
    }
    @keyframes formloader-inner-morph {
        0%,100% { border-radius: 50%; transform: rotate(0deg) scale(1); }
        25%      { border-radius: 40% 60% 60% 40% / 40% 40% 60% 60%; transform: rotate(-120deg) scale(0.88); }
        50%      { border-radius: 50%; transform: rotate(-180deg) scale(1.05); }
        75%      { border-radius: 60% 40% 40% 60% / 60% 60% 40% 40%; transform: rotate(-270deg) scale(0.9); }
    }
    @keyframes formloader-fadetext {
        0%,100% { opacity: 0.4; }
        50%      { opacity: 1; }
    }
`;

function MorphBlob() {
    return (
        <div style={{ position: 'relative', width: 68, height: 68, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {/* Outer soft shell */}
            <div style={{
                position: 'absolute',
                width: 68, height: 68,
                background: '#ede9fe',
                animation: 'formloader-morph 3s ease-in-out infinite',
            }} />
            {/* Inner bold core */}
            <div style={{
                position: 'absolute',
                width: 44, height: 44,
                background: '#3226db',
                animation: 'formloader-inner-morph 3s ease-in-out infinite',
            }} />
            {/* Centre dot */}
            <div style={{
                position: 'absolute',
                width: 16, height: 16,
                background: '#ede9fe',
                borderRadius: '50%',
            }} />
        </div>
    );
}

export function FormLoader({ isLoading, text, subtext, showSubtext = true, showLogoutBtn = false, children }) {
    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("language");
        localStorage.clear();
        window.location.href = "/";
    };

    const logoutButton = () => {
            return <Button size='sm' onClick={logout}><LuLogOut /> Log Out</Button>
    }
    return (
        <>
            {isLoading && createPortal(
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0, 0, 0, 0.48)',
                        backdropFilter: 'blur(4px)',
                        WebkitBackdropFilter: 'blur(4px)',
                        zIndex: 2147483647,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                >
                    <div style={{
                        background: '#fff',
                        borderRadius: 24,
                        padding: '44px 56px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 24,
                        border: '1px solid rgba(0,0,0,0.06)',
                    }}>
                        <MorphBlob />

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 6,
                            textAlign: 'center',
                        }}>
                            <p style={{
                                margin: 0,
                                fontSize: 15,
                                fontWeight: 500,
                                color: '#111827',
                                letterSpacing: '0.01em',
                            }}>
                                {text || 'Processing your request'}
                            </p>
                            <p style={{
                                margin: 0,
                                fontSize: 13,
                                color: '#6b7280',
                                animation: 'formloader-fadetext 2s ease-in-out infinite',
                            }}>
                                {showSubtext ? subtext || 'Please wait...' : ""}
                            </p>

                            <p style={{
                                margin: 0,
                                fontSize: 13,
                                color: '#6b7280',
                            }}>
                                {showLogoutBtn ? logoutButton() : ""}
                            </p>

                        </div>
                    </div>

                    <style>{loaderStyles}</style>
                </div>,
                document.body
            )}

            {children}
        </>
    );
}